import styled from 'styled-components';
import { rgba } from 'polished';
import Grid from '@material-ui/core/Grid';

// CONSTANTS
import { BRIGHT, WHITE, BLACK } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

// COMPONENTS
import DialogCTA from '@/components/Dialogs/DialogCTA';

export const Container = styled.div`
  margin-bottom: 100px;

  button[type='submit'] {
    margin-top: 40px;
    width: 100%;
  }

  ${breakpoints.up('md')} {
    button[type='submit'] {
      max-width: 280px;
    }
  }
`;

export const ChannelsGrid = styled(Grid)`
  .MuiGrid-item {
    display: flex;
  }

  .channel-card {
    display: flex;
    width: 100%;

    &--hover {
      &:hover {
        box-shadow: 0 20px 40px 0 ${rgba(BLACK, 0.08)};
        cursor: default;
      }
    }

    .channel-card__container {
      padding: 10px;
      background-color: ${WHITE};
      min-height: 68px;

      img {
        max-width: 100%;

        @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
          width: 100%;
        }
      }
    }
  }
`;

export const DialogChannels = styled(DialogCTA)`
  .dialog-cta {
    &__content {
      background-color: ${BRIGHT};
      border-radius: 16px;
    }

    &__title {
      text-align: center;
    }
  }
`;

export default Container;
